module.exports = __webpack_public_path__ + "img/figure-7.7d31cbc5.png";